import {
  FOC_TOUR_LABEL_EXT,
  focFeedbackPopoverHtml,
} from '../focTourFeedback';
import { FOC_EXT_TOUR_HREF as HREF } from '../focTourHrefs';
import {
  FOC_REQUIRED_DISPOSITION,
  focExtTourPopoverHtml,
  requirement,
  type FocExtTourStepDef,
} from './focExtTourTypes';

export const FOC_EXT_TOUR_PARAM = 'focExtTour';
export const FOC_EXT_TOUR_HREF = HREF;
export { focExtTourPopoverHtml };

export function focExtTourRosterHref(incidentId: string): string {
  return `/iap/${incidentId}/roster?${FOC_EXT_TOUR_PARAM}=1`;
}

export const FOC_EXT_TOUR_STEPS: FocExtTourStepDef[] = [
  {
    id: 'sectionIntro',
    tour: 'external-collaboration',
    title: FOC_TOUR_LABEL_EXT,
    description:
      'Authorized external collaboration covers interagency, port-partner, stakeholder, contractor, and other approved external users—with lifecycle, restrictions, and protected-information controls.',
  },
  requirement({
    id: 'ext001',
    requirementId: 'FOC-EXT-001',
    name: 'Authorized External Collaboration',
    disposition: FOC_REQUIRED_DISPOSITION,
    tour: 'external-collaboration',
    description:
      'PRATUS supports authorized external collaboration for interagency, port-partner, stakeholder, contractor, and other approved external users.',
    bullets: [
      'FOC-EXT-001a — External User Functions: participate in incident workspaces, collaborate, view authorized COP content, upload documents, contribute information, and identify resources they own or can provide.',
      'FOC-EXT-001b — Coast Guard Resource Authority: external users do not receive authority to request, order, allocate, approve, or release Coast Guard resources unless expressly authorized through approved role and permission controls.',
    ],
  }),
  requirement({
    id: 'ext002',
    requirementId: 'FOC-EXT-002',
    name: 'External User Lifecycle',
    disposition: FOC_REQUIRED_DISPOSITION,
    tour: 'roster-add-external',
    description:
      'Supports invitation, identity confirmation, sponsorship, role assignment, incident/workspace assignment, access review, demobilization-triggered expiration, incident-closure expiration, and audit history.',
  }),
  requirement({
    id: 'ext003',
    requirementId: 'FOC-EXT-003',
    name: 'External User Restrictions',
    disposition: FOC_REQUIRED_DISPOSITION,
    tour: 'roster-external-persistent',
    description:
      'External users do not receive file-download authority by default. C5I/security validation determines authorized download, export, sharing, search, notification, and retention rules.',
  }),
  requirement({
    id: 'ext004',
    requirementId: 'FOC-EXT-004',
    name: 'Protected Information',
    disposition: FOC_REQUIRED_DISPOSITION,
    tour: 'external-collaboration',
    description:
      'Prevents external-user access to Law Enforcement Sensitive information, Blue Forces information, CUI, HIPAA-related information, SSI, and other restricted information unless the user has approved access and the information is authorized for that user’s workspace and role.',
  }),
  requirement({
    id: 'ext005',
    requirementId: 'FOC-EXT-005',
    name: 'Partner Access Dependency',
    disposition: FOC_REQUIRED_DISPOSITION,
    tour: 'external-collaboration',
    description:
      'External-user identity, authentication, sponsorship, access, and data-sharing workflows align with applicable C5I/security direction, including approved CAC and alternative authentication methods for interagency collaboration.',
  }),
  {
    id: 'focFeedback',
    title: 'FOC Feedback Notes',
    description: focFeedbackPopoverHtml(FOC_TOUR_LABEL_EXT),
  },
];

export function focExtTourNavVisible(enabled: boolean): boolean {
  return enabled;
}

export function focExtTourStepIds(): string[] {
  return FOC_EXT_TOUR_STEPS.map((step) => step.id);
}
